export default "__VITE_ASSET__wIGjNToh__"